export enum CustomerTrendWeeklyProfitSortFieldEnum {
  CustomerName = 'customerName',
  Total = 'profitAmountTotal',
  TotalPercentage = 'percentageOfGreatTotal',
}
